import React from 'react';
import DrawerForm from 'components/DrawerForm';
import { Input, Form } from 'antd';

const EditGlobalFilterDrawer = ({ open, globalFilter, onSubmit, onRemove, onCancel }) => (
  <DrawerForm
    open={open}
    onSubmit={onSubmit}
    onCancel={onCancel}
    title={`Edit global filter ${globalFilter.title}`}
    initialValues={globalFilter}
    onRemove={onRemove}
  >
    <Form.Item label="Title" name="title">
      <Input />
    </Form.Item>
  </DrawerForm>
);

export default EditGlobalFilterDrawer;
